import exceptionHandler from "./exception-handler";
import "./css/base.css";

exceptionHandler();
